/**
 * skin-cancer.ts
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

import { registerPlugins } from '#plugins/index.js'

// Components
import SkinCancerVue from './views/skin-cancer/skin-cancer.vue'

// Composables
import { createApp } from 'vue'

// Styles
import 'unfonts.css'

import { store } from '#stores/skin-cancer.js'

async function goApp() {
    const app = createApp(SkinCancerVue)
    registerPlugins(app, 'skinCancer')
    await store.dbinit()
    app.mount('#app')
}

goApp()
